export default function ContactIcon() {
  return (
    <svg
      viewBox="0 0 53 53"
      height="53"
      width="53"
      preserveAspectRatio="xMidYMid meet"
      class=""
      version="1.1"
      x="0px"
      y="0px"
      enable-background="new 0 0 53 53"
    >
      <g>
        <defs>
          <circle id="contact-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
        </defs>
        <clipPath id="contact-SVGID_2_"></clipPath>
        <g clip-path="url(#contact-SVGID_2_)">
          <g>
            <path
              fill="#0795DC"
              d="M26.5-1.1C11.9-1.1-1.1,5.6-1.1,27.6h55.2C54,8.6,41.1-1.1,26.5-1.1z"
            ></path>
            <path
              fill="#0EABF4"
              d="M53,26.5H-1.1c0,14.6,13,27.6,27.6,27.6s27.6-13,27.6-27.6C54.1,26.5,53,26.5,53,26.5z"
            ></path>
          </g>
        </g>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-contact"
          d="M26.5 26.5C28.986 26.5 31 24.486 31 22 31 19.514 28.986 17.5 26.5 17.5 24.014 17.5 22 19.514 22 22 22 24.486 24.014 26.5 26.5 26.5ZM26.5 28.75C23.496 28.75 17.5 30.258 17.5 33.25L17.5 34.375C17.5 34.994 18.006 35.5 18.625 35.5L34.375 35.5C34.994 35.5 35.5 34.994 35.5 34.375L35.5 33.25C35.5 30.258 29.504 28.75 26.5 28.75Z"
        ></path>
      </g>
    </svg>
  );
}
